export default "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?66f2d337503c6bd54e84f793c0b80ce6";